import { styled } from "goober";
import { useState } from "react";
import { ConnectorLogoContainer } from "../ConnectorLogoContainer";
import { Icon, type IconName } from "../Icon";
import { PressButton } from "../PressButton";
import { Text } from "../Text";

// `data-no-pill` opts out of the global button-pill rule so the card keeps its
// 12px corners — matching the Browse apps cards.
const Card = styled(PressButton)`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  width: 100%;
  text-align: left;
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);

  &:hover {
    background: var(--surface-hover);
  }
`;

const Details = styled("div")`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

type Props = {
  name: string;
  description: string;
  icon?: IconName;
  disabled?: boolean;
  onSelect: () => void;
};

export function SkillOption({
  name,
  description,
  icon = "graduation-cap",
  disabled,
  onSelect,
}: Props) {
  const [hover, setHover] = useState(false);

  return (
    <Card
      data-no-pill
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onPress={onSelect}
    >
      <ConnectorLogoContainer
        size={32}
        hover={hover}
        borderRadius={8}
        outline={false}
        hoverBackground={false}
      >
        <Icon name={icon} size={16} />
      </ConnectorLogoContainer>
      <Details>
        <Text variant="text-regular-md" color="var(--text-primary)" ellipsis>
          {name}
        </Text>
        <Text variant="text-small" color="var(--text-secondary)" ellipsis>
          {description}
        </Text>
      </Details>
    </Card>
  );
}
